import moment from "moment";

export const handleActiveFilter = (mainData, filterOptions) => {
  let today = new Date();

  let findAnyCustomer = mainData.reduce((acc, c) => {
    const {
      startCreateDate,
      endCreateDate,
      mikrotik,
      olt,
      mikrotikPackage,
      hotspotPackage,
      area,
      subArea,
      poleBox,
      status,
      paymentStatus,
      reseller,
      bandwidthReseller,
      createdBy,
      collectedBy,
      allCustomer,
      billDayLeft,
      startDate,
      endDate,
      startPromiseDate,
      endPromiseDate,
      changeCustomer,
      userType,
      billType,
      billingType,
      medium,
      action,
      connectionStatus,
      payment,
    } = filterOptions;

    // make date object
    const createDate = new Date(c.createdAt);

    const billingCycle = new Date(c.billingCycle);
    const promiseDate = new Date(c.promiseDate);

    const billingStartData = new Date(startDate);
    const billingEndData = new Date(endDate);

    const promiseStartData = new Date(startPromiseDate);
    const promiseEndData = new Date(endPromiseDate);

    const monthCreateDateStart = new Date(startCreateDate);
    const monthCreateDateEnd = new Date(endCreateDate);

    // current start & end date
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0,
    );
    lastDayOfMonth.setHours(23, 59, 59, 999);

    const dayLeft = Math.round(
      moment(c.billingCycle).diff(moment(), "hours") / 24,
    );

    // make connection status true or false
    let autoConnection;
    if (changeCustomer === "true") {
      autoConnection = false;
    } else if (changeCustomer === "false") {
      autoConnection = true;
    }

    // make possible conditions objects if the filter value not selected thats return true
    //if filter value exist then compare
    const conditions = {
      createDate:
        startCreateDate && endCreateDate
          ? monthCreateDateStart <= createDate &&
            monthCreateDateEnd >= createDate
          : true,
      mikrotik: mikrotik ? c.mikrotik === mikrotik : true,
      olt: olt ? c.olt === olt : true,
      package: mikrotikPackage ? c.mikrotikPackage === mikrotikPackage : true,
      hotspotPackage: hotspotPackage
        ? c.hotspotPackage === hotspotPackage
        : true,
      area: area ? c.area === area : true,
      subArea: subArea ? c.subArea === subArea : true,
      poleBox: poleBox ? c.poleBox === poleBox : true,
      status: status ? c.status === status : true,
      paid: paymentStatus ? c.paymentStatus === "paid" : true,
      unpaid: paymentStatus
        ? c.paymentStatus === "unpaid" && c.monthlyFee !== 0
        : true,
      free: paymentStatus ? c.monthlyFee === 0 : true,
      partial: paymentStatus
        ? c.paymentStatus === "unpaid" &&
          c.monthlyFee > c.balance &&
          c.balance > 0
        : true,
      advance: paymentStatus
        ? c.monthlyFee <= c.balance && c.monthlyFee > 0
        : true,
      overDue: paymentStatus
        ? c.paymentStatus === "unpaid" && c.balance < 0
        : true,
      reseller: reseller ? c.reseller === reseller : true,
      bandwidthReseller: bandwidthReseller
        ? c.reseller === bandwidthReseller
        : true,
      createdBy: createdBy ? c.createdBy === createdBy : true,
      collectedBy: collectedBy ? c.collectorId === collectedBy : true,
      freeUser: allCustomer ? c.monthlyFee === 0 : true,
      nonFreeUser: allCustomer ? c.monthlyFee > 0 : true,
      prepaid: allCustomer ? c.customerBillingType === "prepaid" : true,
      postpaid: allCustomer ? c.customerBillingType === "postpaid" : true,
      newUser: allCustomer
        ? firstDayOfMonth <= createDate && lastDayOfMonth >= createDate
        : true,
      billDayLeft: billDayLeft ? dayLeft === Number(billDayLeft) : true,
      billingDate:
        startDate && endDate
          ? billingStartData <= billingCycle && billingEndData >= billingCycle
          : true,
      promiseDate:
        startPromiseDate && endPromiseDate
          ? promiseStartData <= promiseDate && promiseEndData >= promiseDate
          : true,
      promiseDateChange:
        changeCustomer === "promiseDate"
          ? billingCycle < promiseDate || billingCycle > promiseDate
          : true,
      autoDisable: changeCustomer ? c.autoDisable !== autoConnection : true,
      userType: userType ? c.userType === userType : true,
      billType: billType ? c.billType === billType : true,
      billingType: billingType ? c.billingType === billingType : true,
      medium: medium
        ? "onlinePayment" === medium
          ? ["sslcommerz", "uddoktapay", "sslpay", "bKashPG"].includes(c.medium)
          : c.medium === medium
        : true,
      action: action ? c.action === action : true,
      online: connectionStatus === "online" ? c.running === true : true,
      offline: connectionStatus === "offline" ? c.running !== true : true,
      partialPayment: payment
        ? payment === "partialPayment" &&
          c.currentState.paymentStatus === "unpaid" &&
          c.balance > 0 &&
          c.monthlyFee !== c.amount
        : true,
      advancePayment: payment
        ? payment === "advancePayment" &&
          c.currentState.paymentStatus === "paid" &&
          c.monthlyFee <= c.balance
        : true,
      overDuePayment: payment
        ? payment === "overDuePayment" &&
          c.currentState.paymentStatus === "unpaid" &&
          c.amount <= c.due
        : true,
    };

    //check if condition pass got for next step or is fail stop operation
    //if specific filter option value not exist it will return true

    let isPass = false;

    isPass = conditions["createDate"];
    if (!isPass) return acc;

    isPass = conditions["mikrotik"];
    if (!isPass) return acc;

    isPass = conditions["olt"];
    if (!isPass) return acc;

    isPass = conditions["package"];
    if (!isPass) return acc;

    isPass = conditions["hotspotPackage"];
    if (!isPass) return acc;

    isPass = conditions["area"];
    if (!isPass) return acc;

    isPass = conditions["poleBox"];
    if (!isPass) return acc;

    isPass = conditions["subArea"];
    if (!isPass) return acc;

    isPass = conditions["status"];
    if (!isPass) return acc;

    if (paymentStatus) {
      isPass = conditions[paymentStatus];
      if (!isPass) return acc;
    }

    isPass = conditions["reseller"];
    if (!isPass) return acc;

    isPass = conditions["bandwidthReseller"];
    if (!isPass) return acc;

    isPass = conditions["createdBy"];
    if (!isPass) return acc;

    isPass = conditions["collectedBy"];
    if (!isPass) return acc;

    isPass = conditions["billType"];
    if (!isPass) return acc;

    isPass = conditions["billingType"];
    if (!isPass) return acc;

    isPass = conditions["medium"];
    if (!isPass) return acc;

    if (payment) {
      isPass = conditions[payment];
      if (!isPass) return acc;
    }

    if (allCustomer) {
      isPass = conditions[allCustomer];
      if (!isPass) return acc;
    }

    isPass = conditions["billDayLeft"];
    if (!isPass) return acc;

    isPass = conditions["billingDate"];
    if (!isPass) return acc;

    isPass = conditions["promiseDate"];
    if (!isPass) return acc;

    isPass = conditions["promiseDateChange"];
    if (!isPass) return acc;

    isPass = conditions["autoDisable"];
    if (!isPass) return acc;

    isPass = conditions["userType"];
    if (!isPass) return acc;

    isPass = conditions["action"];
    if (!isPass) return acc;

    if (connectionStatus) {
      isPass = conditions[connectionStatus];
      if (!isPass) return acc;
    }

    if (isPass) acc.push(c);

    return acc;
  }, []);

  // set filter customer in customer state
  return findAnyCustomer;
};
